import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { classNames as m } from "../../../Utils/classNames.js";
import { forwardRef as p, useRef as u, useImperativeHandle as f } from "react";
function d({ value: s, onChange: i, errorMessage: n, disabled: t }, l) {
  const a = u(null);
  return f(l, () => ({
    focus: () => {
      var r;
      (r = a.current) == null || r.scrollIntoView({
        behavior: "smooth"
      });
    }
  })), /* @__PURE__ */ c("div", { ref: a, className: "space-y-2", children: [
    /* @__PURE__ */ o("div", { className: "flex space-x-2", children: Array.from({
      length: 5
    }).map((r, e) => /* @__PURE__ */ o(
      "div",
      {
        onClick: () => {
          t || i(e + 1);
        },
        className: m(
          "rounded-full p-4 border-primary border-2",
          t ? "opacity-30 cursor-not-allowed" : s === e + 1 ? "bg-primary" : "bg-white hover:bg-primary cursor-pointer"
        )
      },
      e
    )) }),
    n ? /* @__PURE__ */ o("p", { className: "text-red-600", children: n }) : null
  ] });
}
const y = p(d);
export {
  y as RatingInput
};
